import { EditProtectedAreaPage } from '@features/Property/ProtectedArea/EditProtectedAreaPage'
import { getForestOwnerPropertiesQuery } from '@services/queryOptions'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/property/protected-area/edit')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Rediger vernet areal',
  },
})

function RouteComponent() {
  const { forestownerId } = Route.useParams()
  const { data, isLoading } = useQuery(
    getForestOwnerPropertiesQuery({ forestOwnerId: forestownerId }),
  )

  if (isLoading) return <div>Laster...</div>

  const properties = data?.properties ?? []
  return <EditProtectedAreaPage properties={properties} source="propertyOverview" />
}
